import { useMemo } from "react";
import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { getRecommendedCategories } from "../services/categories";
import {
  IRecommendedCategory,
  IRecommendationPlaceName,
} from "../types/recommendations.types";

export const RECOMMENDED_CATEGORIES_QUERY_KEY = "recommendedCategories";

interface IUseRecommendedCategoriesResult {
  categories: IRecommendedCategory[] | undefined;
  placeName: IRecommendationPlaceName | undefined;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
}

export const useRecommendedCategories = (): IUseRecommendedCategoriesResult => {
  const { data, isLoading, isError, isSuccess } = useDataQuery(
    [RECOMMENDED_CATEGORIES_QUERY_KEY],
    () => getRecommendedCategories().then(({ data }) => data),
    { staleTime: 10 * 60 * 1000 } // 10min
  );

  const categories = useMemo(() => {
    const raw = data?.data.categories;
    return raw ? [...raw].sort(() => Math.random() - 0.5) : raw;
  }, [data?.data.categories]);

  return {
    categories,
    placeName: data?.data.place_name,
    isLoading,
    isError,
    isSuccess,
  };
};
